import { useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const useMatches = () => {
  const [matches, setMatches] = useState([]);

  useEffect(() => {
    if (!API) return undefined;
    let alive = true;
    const load = () => {
      axios.get(`${API}/api/matches/today`)
        .then((r) => { if (alive) setMatches(Array.isArray(r.data?.matches) ? r.data.matches : []); })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return matches;
};

const dayLabel = (iso, i) => {
  if (i === 0) return "Bugün";
  if (i === 1) return "Yarın";
  const d = new Date(`${iso}T12:00:00`);
  return `${d.toLocaleDateString("tr-TR", { weekday: "short" })} ${d.toLocaleDateString("tr-TR", { day: "numeric", month: "short" })}`;
};

export const useBigMatches = (today) => {
  const [days, setDays] = useState([]);

  useEffect(() => {
    if (!API) return undefined;
    let alive = true;
    axios.get(`${API}/api/matches/week`)
      .then((r) => { if (alive) setDays(Array.isArray(r.data?.days) ? r.data.days : []); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return useMemo(() => {
    const fresh = Object.fromEntries(today.map((m) => [m.id, m]));
    return days.flatMap((d, i) =>
      (Array.isArray(d.matches) ? d.matches : []).map((m) => ({ ...m, ...(fresh[m.id] || {}), day: dayLabel(d.date, i) })),
    );
  }, [days, today]);
};
